import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SavedRun } from "../../../packages/contracts/src/workspace";
import { Button } from "./components/ui/button";
import { productionApi } from "./production-api";

const activeStatuses = ["queued", "running", "waiting"];

/** Cancels a run that an app started, while it is queued, running, or waiting. */
export function CancelRun({ run }: { run: Pick<SavedRun, "production"> }) {
  const client = useQueryClient();
  const cancel = useMutation({ mutationFn: productionApi.cancel, onSuccess: () => Promise.all([client.invalidateQueries({ queryKey: ["runs"] }), client.invalidateQueries({ queryKey: ["run"] })]) });
  const production = run.production;
  if (!production || !activeStatuses.includes(production.status)) return null;
  if (production.cancel_requested || cancel.isSuccess) return <span className="list-muted">Cancelling…</span>;
  return <Button variant="secondary" disabled={cancel.isPending} onClick={() => cancel.mutate(production.id)}>Cancel</Button>;
}
